import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=3b8d9bbb&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8d9bbb')) {
      api.createRecord('3b8d9bbb', component.options)
    } else {
      api.reload('3b8d9bbb', component.options)
    }
    module.hot.accept("./Files.vue?vue&type=template&id=3b8d9bbb&", function () {
      api.rerender('3b8d9bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/Files.vue"
export default component.exports